// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__P59HO","label":"Category_label__3KSYP","content":"Category_content__3-VWi","header":"Category_header__m3pdn","location":"Category_location__33ADh"};